import "./service-provider-root.component.scss";

export default {
  template: require('./service-provider-root.component.html'),
  controller: function ($t, $auth, $gl, $alert, ServiceProviderContactUsApi, vuiModals) {
    'ngInject';

    const self = this;

    self.auth = $auth;

    self.submitContactUs = message => {
      $gl.show();
      ServiceProviderContactUsApi.send({body: message},
        response => {
          const successMessage = $t('shared.modals.contact_us.sending_success_message');
          vuiModals.info(successMessage);
          $gl.hide();
        },
        error => {
          $gl.hide();
          $alert.processError(error, $t('public.about.contact_us.send_message_error_message'));
        })
    }
  }
};
